import { VestingSafeSource, VestingSafeType } from '@profile/src/models';
export const formatType = (source, fee) => {
  if (!source) return '';

  switch (source) {
    case VestingSafeSource.VESTING_CLAIM:
      if (fee && parseInt(fee.value) > 0) {
        return 'Secondary Claim';
      }

      return 'Primary Claim';

    case VestingSafeSource.SPECIAL_EVENT_REWARD:
      return 'Thetan Tournament';

    case VestingSafeSource.ADMIN:
      return 'Admin';

    case VestingSafeSource.CREATOR_PROGRAM_CREATOR:
      return 'Creator Program Creator';

    case VestingSafeSource.FUSION_CASHBACK:
      return 'Fusion Reward';

    case VestingSafeSource.FUSION_LEADERBOARD:
      return 'Fusion Competition Reward';

    case VestingSafeSource.TRADING_EVENT_CASHBACK:
      return 'Trading Event Reward';

    case VestingSafeSource.TRADING_EVENT_LEADERBOARD:
      return 'Trading Event Competition Reward';

    default:
      return '';
  }
};
export const formatStatus = type => {
  switch (type) {
    case VestingSafeType.CLAIM:
      return {
        displayName: 'Claim',
        style: 'completed'
      };

    case VestingSafeType.DEPOSIT:
      return {
        displayName: 'Reward',
        style: 'refunded'
      };

    default:
      return '';
  }
};